import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useMemo } from 'react';
import IMG_PRODUCT from './common/images/product-image.png';
import { getImageSrc } from './common/utils/get-image-src';
export var LANGUAGE_VALUES;
(function (LANGUAGE_VALUES) {
  /** 繁體 */
  LANGUAGE_VALUES["TC"] = "tc";
  /** 簡體 */
  LANGUAGE_VALUES["CN"] = "cn";
  /** 英文 */
  LANGUAGE_VALUES["EN"] = "en";
})(LANGUAGE_VALUES || (LANGUAGE_VALUES = {}));
var DEFAULT_VALUE = {
  currency: '$',
  local: {
    goods: {
      specialOffer: '特價優惠',
      addCartButtonText: '加入購物車',
      soldOutButtonText: '售罄',
      viewMoreButtonText: '查看更多',
      soldOut: '商品已售罄',
      unShelve: '商品已下架',
      preSale: '商品預售'
    },
    sale: {
      titleText: '限時優惠',
      dayText: '日',
      saleText: '限時優惠',
      viewMoreButtonText: '查看更多'
    }
  },
  language: LANGUAGE_VALUES.TC,
  countStatistics: {},
  productDefaultImage: getImageSrc(IMG_PRODUCT),
  designOnLink: function designOnLink() {},
  initializeBreakpoint: 'mobile'
};
var DesignContext = /*#__PURE__*/React.createContext(DEFAULT_VALUE);
export function useDesignContext() {
  return useContext(DesignContext);
}
export var DesignProvider = function DesignProvider(_ref) {
  var value = _ref.value,
    children = _ref.children;
  return _jsx(DesignContext.Provider, Object.assign({
    value: useMemo(function () {
      return Object.assign(DEFAULT_VALUE, value);
    }, [value])
  }, {
    children: children
  }));
};